class DapsMotivoRecusaModel{
  constructor(){
    this.id = '';
    this.motivoRecusa = '';
  }
}

export default DapsMotivoRecusaModel;